import {useCallback} from 'react'

import {DockedPanel, type PanelOpenOptions, useDockedPanelActions} from '../contexts/DockedPanelContext'

export function useOpenManageBatchPanel() {
  const {openPanel} = useDockedPanelActions()

  return useCallback(
    (options?: PanelOpenOptions) => openPanel(DockedPanel.ManageBatchReviewComments, options),
    [openPanel],
  )
}
